import styled from "@emotion/styled";
import IconAdd from "@/assets/images/icon-add.svg?react";

export const IconAddStyle = styled(IconAdd)`
  & path {
    fill: #3548c9;
  }
`;

export const Root = styled.form`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  & .theme-table-container {
    overflow-y: unset !important;
  }
  & .card-filter {
    margin: 24px 0;
    .theme-card-body {
      display: flex;
      gap: 12px;
      & > div:first-of-type {
        width: 20%;
      }
      & > div:last-child {
        width: 100%;
      }
    }
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const Title = styled.p`
  font-size: 24px;
  font-weight: 500;
  color: #000000;
`;
export const PortfolioText = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: -0.2px;
  color: #395278;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-line-clamp: 2;
`;

export const GroupButton = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  & > div:nth-of-type(1),
  & > div:nth-of-type(2) {
    width: 20%;
  }
  & > div:nth-of-type(3) {
    width: 60%;
  }
`;

export const TextTemplateName = styled.p`
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: -0.2px;
  color: #3548c9;
`;
